export const ERROR_PIC = 'https://st.tencent-cloud.com/jax-static/qb/c64308b5fd8a8ed244c9a397959e30fe.png';
export const EMPTY_PIC = 'https://st.tencent-cloud.com/jax-static/qb/1402cab105a523913dc097dbfec05ba4.png';
export const LOADING_SVG = 'https://operate-30278.sz.gfp.tencent-cloud.com/qbdesign/iconSvg/std_ic_loading_s.svg';
